module.exports = __webpack_public_path__ + "img/06_DSC7786.49595c98.jpg";